import BackendAPI from '~/api/BackendClient/BackendAPI'
import type { components } from '~/api/BackendClient/generated-schema'

export type DashboardPageResponse = components['schemas']['DashboardPageResponse']

export type DashboardPage_CulturePlate =
  components['schemas']['DashboardPage_CulturePlate']

export type ObservationMetric = components['schemas']['ObservationMetric']

class DashboardPageAPI extends BackendAPI {
  getData = (
    minLastCheckedOut: string,
    pageSize?: number,
    pageToken?: string,
    metrics?: ObservationMetric[],
  ): Promise<DashboardPageResponse> => {
    return this.client.GET('/api/pages/dashboard/', {
      params: {
        query: {
          min_last_checked_out: minLastCheckedOut,
          page_size: pageSize,
          page_token: pageToken,
          metrics: metrics && metrics.length > 0 ? metrics.join(',') : undefined,
        },
      },
    })
  }
}

export default DashboardPageAPI
